var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogolar05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70.87 70.87",
    style: {
      enableBackground: "new 0 0 70.87 70.87"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#fffffff;}\r\n    .st1 { fill-rule: evenodd; clip-rule: evenodd; fill: #000000;} /* \xC7izgi rengini siyah yap ve \xE7izgi kal\u0131nl\u0131\u011F\u0131n\u0131 1px olarak belirle */\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.2,32.26L36.2,32.26v-2.26l-0.09-0.14c-0.46,0.03-0.91,0.03-1.37,0l-0.11,0.11v4.54l0.11,0.12h1.37 l0.09-0.12V32.26z M37.8,42.58h-0.11h-1.37c-0.12,0-0.12,0-0.12-0.14v-6.11l-0.09-0.11c-0.46,0.03-0.91,0.03-1.37,0l-0.11,0.11 v6.11c0,0.14,0,0.14-0.11,0.14h-1.37h-0.09l-0.03-0.14V28.49c0-0.2,0-0.2,0.2-0.2h4.45c0.11,0,0.11,0,0.11,0.12v14.03V42.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.29,28.29h0.17h2.88c0.11,0,0.11,0,0.11,0.12v1.34c0,0.12,0,0.12-0.14,0.12h-1.31 c-0.14,0-0.14,0.03-0.14,0.14v4.49c0,0.14,0,0.14,0.14,0.14h1.31c0.14,0,0.14,0,0.14,0.14v1.32c0,0.11,0,0.11-0.14,0.11h-1.31 c-0.14,0-0.14,0.03-0.14,0.14v4.49c0,0.14,0,0.14,0.14,0.14h1.31c0.14,0,0.14,0,0.14,0.11v1.34c0,0.14,0,0.14-0.11,0.14h-2.94 h-0.11V28.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.57,40.98v1.6h-0.11h-2.94c-0.14,0-0.14,0-0.14-0.12V28.41c0-0.09,0.03-0.12,0.11-0.12h3h0.09v1.57 l-0.14,0.03h-1.31c-0.14,0-0.14,0-0.14,0.11v10.83c0,0.14,0,0.14,0.14,0.14h1.31H42.57z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogolar05);
export default __webpack_public_path__ + "static/media/logolar-05.7dec2c900f34918b01a415520b1da033.svg";
export { ForwardRef as ReactComponent };